{
  "00010": [
    {
      "branchCode": "13100",
      "name": "BCC - AGENCE DE",
      "shortName": "BULUNGU"
    },
    {
      "branchCode": "24000",
      "name": "BCC - AGENCE DE KALEMIE",
      "shortName": "KALEMIE"
    },
    {
      "branchCode": "13000",
      "name": "BCC - BANDUNDU",
      "shortName": "BANDUNDU"
    },
    {
      "branchCode": "19100",
      "name": "BCC - BENI",
      "shortName": "BENI"
    },
    {
      "branchCode": "00071",
      "name": "BCC - BENI",
      "shortName": "BENI"
    },
    {
      "branchCode": "26000",
      "name": "BCC - BOENDE",
      "shortName": "BOENDE"
    },
    {
      "branchCode": "00020",
      "name": "BCC - BOMA",
      "shortName": "BCC"
    },
    {
      "branchCode": "11100",
      "name": "BCC - BOMA",
      "shortName": "BOMA"
    },
    {
      "branchCode": "22000",
      "name": "BCC - BUKAVU",
      "shortName": "BUKAVU"
    },
    {
      "branchCode": "00070",
      "name": "BCC - BUKAVU",
      "shortName": "BUKAVU"
    },
    {
      "branchCode": "18000",
      "name": "BCC - BUMBA",
      "shortName": "BUMBA"
    },
    {
      "branchCode": "00052",
      "name": "BCC - BUNIA",
      "shortName": "BUNIA"
    },
    {
      "branchCode": "01000",
      "name": "BCC - BUTA",
      "shortName": "BUTA"
    },
    {
      "branchCode": "19200",
      "name": "BCC - BUTEMBO",
      "shortName": "BUTEMBO"
    },
    {
      "branchCode": "00074",
      "name": "BCC - BUTEMBO",
      "shortName": "BUTEMBO"
    },
    {
      "branchCode": "15200",
      "name": "BCC - FUNGURUME",
      "shortName": "FUNGURUME"
    },
    {
      "branchCode": "00035",
      "name": "BCC - FUNGURUME",
      "shortName": "FUNGURUME"
    },
    {
      "branchCode": "20000",
      "name": "BCC - GBADOLITE",
      "shortName": "GBADOLITE"
    },
    {
      "branchCode": "23000",
      "name": "BCC - GEMENA",
      "shortName": "GEMENA"
    },
    {
      "branchCode": "19000",
      "name": "BCC - GOMA",
      "shortName": "GOMA"
    },
    {
      "branchCode": "00072",
      "name": "BCC - GOMA",
      "shortName": "GOMA"
    },
    {
      "branchCode": "03000",
      "name": "BCC - HAUT KATANGA",
      "shortName": "HAUT KATAN"
    },
    {
      "branchCode": "07100",
      "name": "BCC - ILEBO",
      "shortName": "ILEBO"
    },
    {
      "branchCode": "16000",
      "name": "BCC - INONGO",
      "shortName": "INONGO"
    },
    {
      "branchCode": "05000",
      "name": "BCC - ISIRO",
      "shortName": "ISIRO"
    },
    {
      "branchCode": "14000",
      "name": "BCC - KABINDA",
      "shortName": "KABINDA"
    },
    {
      "branchCode": "04000",
      "name": "BCC - KAMINA",
      "shortName": "KAMINA"
    },
    {
      "branchCode": "08000",
      "name": "BCC - KANANGA",
      "shortName": "KANANGA"
    },
    {
      "branchCode": "00090",
      "name": "BCC - KANANGA",
      "shortName": "KANANGA"
    },
    {
      "branchCode": "03100",
      "name": "BCC - KASUMBALESA",
      "shortName": "KASUMBALES"
    },
    {
      "branchCode": "31000",
      "name": "BCC - KIKWIT",
      "shortName": "KIKWIT"
    },
    {
      "branchCode": "17000",
      "name": "BCC - KINDU",
      "shortName": "KINDU"
    },
    {
      "branchCode": "00050",
      "name": "BCC - KISANGANI",
      "shortName": "KISANGANI"
    },
    {
      "branchCode": "25000",
      "name": "BCC - KISANGANI",
      "shortName": "KISANGANI"
    },
    {
      "branchCode": "00034",
      "name": "BCC - KOLWEZI",
      "shortName": "KOLWEZI"
    },
    {
      "branchCode": "24100",
      "name": "BCC - KONGOLO",
      "shortName": "KONGOLO"
    },
    {
      "branchCode": "00032",
      "name": "BCC - LIKASI",
      "shortName": "LIKASI"
    },
    {
      "branchCode": "21100",
      "name": "BCC - LODJA",
      "shortName": "LODJA"
    },
    {
      "branchCode": "00030",
      "name": "BCC - LUBUMBASHI",
      "shortName": "LUBUMBASHI"
    },
    {
      "branchCode": "11000",
      "name": "BCC - MATADI",
      "shortName": "MATADI"
    },
    {
      "branchCode": "00021",
      "name": "BCC - MATADI",
      "shortName": "MATADI"
    },
    {
      "branchCode": "00060",
      "name": "BCC - MBUJIMAYI",
      "shortName": "MBUJIMAYI"
    },
    {
      "branchCode": "07200",
      "name": "BCC - TSHIKAPA",
      "shortName": "TSHIKAPA"
    },
    {
      "branchCode": "22100",
      "name": "BCC - UVIRA",
      "shortName": "UVIRA"
    },
    {
      "branchCode": "20100",
      "name": "BCC - ZONGO",
      "shortName": "ZONGO"
    },
    {
      "branchCode": "00023",
      "name": "MBANZA NGUNGU",
      "shortName": "MBANZA"
    },
    {
      "branchCode": "10000",
      "name": "SIEGE DE KINSHASA GOMBE",
      "shortName": "GOMBE"
    }
  ],
  "00011": [
    {
      "branchCode": "00172",
      "name": "BANQUE COMMERCIALE DU CONGO",
      "shortName": "GOMA"
    },
    {
      "branchCode": "00135",
      "name": "BANQUE COMMERCIALE DU CONGO",
      "shortName": "FUNGURUME"
    },
    {
      "branchCode": "00130",
      "name": "BANQUE COMMERCIALE DU CONGO",
      "shortName": "LUBUMBASHI"
    },
    {
      "branchCode": "05101",
      "name": "BANQUE COMMERCIALE DU CONGO",
      "shortName": "KINSHA LF"
    },
    {
      "branchCode": "00154",
      "name": "BANQUE COMMERCIALE DU CONGO",
      "shortName": "ISIRO"
    },
    {
      "branchCode": "00174",
      "name": "BANQUE COMMERCIALE DU CONGO",
      "shortName": "BUTEMBO"
    },
    {
      "branchCode": "07101",
      "name": "BANQUE COMMERCIALE DU CONGO",
      "shortName": "KINTAMBO"
    },
    {
      "branchCode": "10101",
      "name": "BANQUE COMMERCIALE DU CONGO",
      "shortName": "CENTRAL"
    },
    {
      "branchCode": "00171",
      "name": "BANQUE COMMERCIALE DU CONGO",
      "shortName": "BENI"
    },
    {
      "branchCode": "03101",
      "name": "BANQUE COMMERCIALE DU CONGO",
      "shortName": "MATONGE"
    },
    {
      "branchCode": "08101",
      "name": "BANQUE COMMERCIALE DU CONGO",
      "shortName": "BCDC KINTA"
    },
    {
      "branchCode": "00155",
      "name": "BANQUE COMMERCIALE DU CONGO",
      "shortName": "MONGBWALU"
    },
    {
      "branchCode": "01101",
      "name": "BANQUE COMMERCIALE DU CONGO",
      "shortName": "MLIMETE"
    },
    {
      "branchCode": "00152",
      "name": "BANQUE COMMERCIALE DU CONGO",
      "shortName": "BUNIA"
    },
    {
      "branchCode": "04101",
      "name": "BANQUE COMMERCIALE DU CONGO",
      "shortName": "UNIKIN"
    },
    {
      "branchCode": "00132",
      "name": "BANQUE COMMERCIALE DU CONGO",
      "shortName": "LIKASI"
    },
    {
      "branchCode": "00170",
      "name": "BANQUE COMMERCIALE DU CONGO",
      "shortName": "BUKAVU"
    },
    {
      "branchCode": "00190",
      "name": "BANQUE COMMERCIALE DU CONGO",
      "shortName": "KANANGA"
    },
    {
      "branchCode": "00160",
      "name": "BANQUE COMMERCIALE DU CONGO",
      "shortName": "MBUJIMAYI"
    },
    {
      "branchCode": "00157",
      "name": "BANQUE COMMERCIALE DU CONGO",
      "shortName": "DURBA"
    },
    {
      "branchCode": "00134",
      "name": "BANQUE COMMERCIALE DU CONGO",
      "shortName": "KOLWEZI"
    },
    {
      "branchCode": "00120",
      "name": "BANQUE COMMERCIALE DU CONGO BO",
      "shortName": "BCDC BOMA"
    },
    {
      "branchCode": "00101",
      "name": "BANQUE COMMERCIALE DU CONGO KI",
      "shortName": "BCDC KIN"
    },
    {
      "branchCode": "00126",
      "name": "BANQUE COMMERCIALE DU CONGO LU",
      "shortName": "LUKALA"
    },
    {
      "branchCode": "00121",
      "name": "BANQUE COMMERCIALE DU CONGO MA",
      "shortName": "BCDC MATAD"
    },
    {
      "branchCode": "09101",
      "name": "BANQUE COMMERCIALE DU CONGO MA",
      "shortName": "BRIKIN"
    },
    {
      "branchCode": "15066",
      "name": "BENI",
      "shortName": "BENI"
    },
    {
      "branchCode": "15052",
      "name": "BOMA",
      "shortName": "BOMA"
    },
    {
      "branchCode": "15065",
      "name": "BUKAVU",
      "shortName": "BUKAVU"
    },
    {
      "branchCode": "15060",
      "name": "BUNIA",
      "shortName": "BUNIA"
    },
    {
      "branchCode": "15068",
      "name": "BUTEMBO",
      "shortName": "BUTEMBO"
    },
    {
      "branchCode": "15063",
      "name": "DURBA",
      "shortName": "DURBA"
    },
    {
      "branchCode": "15058",
      "name": "FUNGURUME",
      "shortName": "FUNGURUME"
    },
    {
      "branchCode": "15067",
      "name": "GOMA",
      "shortName": "GOMA"
    },
    {
      "branchCode": "15061",
      "name": "ISIRO",
      "shortName": "ISIRO"
    },
    {
      "branchCode": "15069",
      "name": "KANANGA",
      "shortName": "KANANGA"
    },
    {
      "branchCode": "15054",
      "name": "KIMPESE",
      "shortName": "KIMPESE"
    },
    {
      "branchCode": "15075",
      "name": "KINSHASA KITEA",
      "shortName": "KINSHASA K"
    },
    {
      "branchCode": "15077",
      "name": "KINSHASA-BRIKIN",
      "shortName": "KINSHASA-B"
    },
    {
      "branchCode": "15071",
      "name": "KINSHASA-GOMBE",
      "shortName": "KINSHASA-G"
    },
    {
      "branchCode": "15076",
      "name": "KINSHASA-KINTAMBO",
      "shortName": "KINSHASA-K"
    },
    {
      "branchCode": "15074",
      "name": "KINSHASA-LHF",
      "shortName": "KINSHASA-L"
    },
    {
      "branchCode": "15070",
      "name": "KINSHASA-LIMETE",
      "shortName": "KINSHASA-L"
    },
    {
      "branchCode": "15078",
      "name": "KINSHASA-MARCHE CENTRAL",
      "shortName": "KINSHASA-M"
    },
    {
      "branchCode": "15072",
      "name": "KINSHASA-MATONGE",
      "shortName": "KINSHASA-M"
    },
    {
      "branchCode": "15051",
      "name": "KINSHASA-SIEGE",
      "shortName": "KINSHASA"
    },
    {
      "branchCode": "15079",
      "name": "KINSHASA-UCC MONT NGAFULA",
      "shortName": "KINSHASA-U"
    },
    {
      "branchCode": "15073",
      "name": "KINSHASA-UNIKIN",
      "shortName": "KINSHASA-U"
    },
    {
      "branchCode": "15059",
      "name": "KISANGANI",
      "shortName": "KISANGANI"
    },
    {
      "branchCode": "15057",
      "name": "KOLWEZI",
      "shortName": "KOLWEZI"
    },
    {
      "branchCode": "15056",
      "name": "LIKASI",
      "shortName": "LIKASI"
    },
    {
      "branchCode": "15055",
      "name": "LUBUMBASHI",
      "shortName": "LUBUMBASHI"
    },
    {
      "branchCode": "15053",
      "name": "MATADI",
      "shortName": "MATADI"
    },
    {
      "branchCode": "15064",
      "name": "MBUJIMAYI",
      "shortName": "MBUJIMAYI"
    },
    {
      "branchCode": "15062",
      "name": "MONGBWALU",
      "shortName": "MONGBWALU"
    },
    {
      "branchCode": "15000",
      "name": "SIEGE",
      "shortName": "SIEGE"
    },
    {
      "branchCode": "15092",
      "name": "TSHIKAPA  BRANCH",
      "shortName": "TSHIKAPA"
    }
  ],
  "00013": [
    {
      "branchCode": "00857",
      "name": "CITIBANK DURBA",
      "shortName": "DURBA"
    },
    {
      "branchCode": "00821",
      "name": "CITIBANK MATADI",
      "shortName": "MATADI"
    },
    {
      "branchCode": "00001",
      "name": "CITIBANK SIEGE",
      "shortName": "CITIBANKSI"
    },
    {
      "branchCode": "00830",
      "name": "CITIGROUP CONGO - LUBUMBASHI",
      "shortName": "LUBUMBASHI"
    }
  ],
  "00014": [
    {
      "branchCode": "00420",
      "name": "BOMA",
      "shortName": "BOMA"
    },
    {
      "branchCode": "00402",
      "name": "BUKAVU",
      "shortName": "BUKAVU"
    },
    {
      "branchCode": "00452",
      "name": "BUNIA",
      "shortName": "BUNIA"
    },
    {
      "branchCode": "28200",
      "name": "BUTEMBO",
      "shortName": "BUTEMBO"
    },
    {
      "branchCode": "25000",
      "name": "FBN BANK - LUBUMBASHI",
      "shortName": "LUBUMBASHI"
    },
    {
      "branchCode": "28001",
      "name": "FBN BANK GOMA 2",
      "shortName": "GOMA 2"
    },
    {
      "branchCode": "00401",
      "name": "FBNBANK",
      "shortName": "FBNBANK"
    },
    {
      "branchCode": "21000",
      "name": "FBNBANK  MATADI",
      "shortName": "MATADI"
    },
    {
      "branchCode": "11008",
      "name": "FBNBANK - 24 NOVEMBRE",
      "shortName": "24 NOVEMBR"
    },
    {
      "branchCode": "24400",
      "name": "FBNBANK - ARU",
      "shortName": "ARU"
    },
    {
      "branchCode": "28100",
      "name": "FBNBANK - BENI",
      "shortName": "BENI"
    },
    {
      "branchCode": "00471",
      "name": "FBNBANK - BENI",
      "shortName": "BENI"
    },
    {
      "branchCode": "21100",
      "name": "FBNBANK - BOMA",
      "shortName": "BOMA"
    },
    {
      "branchCode": "11006",
      "name": "FBNBANK - BON MARCHE",
      "shortName": "BON MARCHE"
    },
    {
      "branchCode": "11011",
      "name": "FBNBANK - BOULEVARD",
      "shortName": "BOULEVARD"
    },
    {
      "branchCode": "22000",
      "name": "FBNBANK - BUKAVU",
      "shortName": "BUKAVU"
    },
    {
      "branchCode": "24100",
      "name": "FBNBANK - BUNIA",
      "shortName": "BUNIA"
    },
    {
      "branchCode": "00457",
      "name": "FBNBANK - DURBA",
      "shortName": "DURBA"
    },
    {
      "branchCode": "11005",
      "name": "FBNBANK - GAMBELA",
      "shortName": "GAMBELA"
    },
    {
      "branchCode": "26500",
      "name": "FBNBANK - GEMENA",
      "shortName": "GEMENA"
    },
    {
      "branchCode": "00472",
      "name": "FBNBANK - GOMA",
      "shortName": "GOMA"
    },
    {
      "branchCode": "28000",
      "name": "FBNBANK - GOMA",
      "shortName": "GOMA"
    },
    {
      "branchCode": "11009",
      "name": "FBNBANK - KABAMBARE",
      "shortName": "KABAMBARE"
    },
    {
      "branchCode": "23000",
      "name": "FBNBANK - KANANGA",
      "shortName": "KANANGA"
    },
    {
      "branchCode": "20100",
      "name": "FBNBANK - KIKWIT",
      "shortName": "KIKWIT"
    },
    {
      "branchCode": "11000",
      "name": "FBNBANK - KINSHASA",
      "shortName": "KINSHASA"
    },
    {
      "branchCode": "11500",
      "name": "FBNBANK - KINSHASA 11500",
      "shortName": "KINSHASA"
    },
    {
      "branchCode": "24000",
      "name": "FBNBANK - KISANGANI",
      "shortName": "KISANGANI"
    },
    {
      "branchCode": "11014",
      "name": "FBNBANK - LIMETE",
      "shortName": "LIMETE"
    },
    {
      "branchCode": "21500",
      "name": "FBNBANK - LUKULA",
      "shortName": "LUKULA"
    },
    {
      "branchCode": "24500",
      "name": "FBNBANK - MAHAGI",
      "shortName": "MAHAGI"
    },
    {
      "branchCode": "11004",
      "name": "FBNBANK - MASINA",
      "shortName": "MASINA"
    },
    {
      "branchCode": "11040",
      "name": "FBNBANK - MASINA II",
      "shortName": "MASINA II"
    },
    {
      "branchCode": "00842",
      "name": "FBNBANK - MATADI",
      "shortName": "MATADI"
    },
    {
      "branchCode": "11007",
      "name": "FBNBANK - NGIRI NGIRI",
      "shortName": "NGIRI NGIR"
    },
    {
      "branchCode": "25800",
      "name": "FBNBANK - PWETO",
      "shortName": "PWETO"
    },
    {
      "branchCode": "11012",
      "name": "FBNBANK - ROND POINT NGABA",
      "shortName": "ROND POINT"
    },
    {
      "branchCode": "11003",
      "name": "FBNBANK - SOCIMAT",
      "shortName": "SOCIMAT"
    },
    {
      "branchCode": "11002",
      "name": "FBNBANK - TOMBALBAYE",
      "shortName": "TOMBALBAYE"
    },
    {
      "branchCode": "11010",
      "name": "FBNBANK - UPN",
      "shortName": "UPN"
    },
    {
      "branchCode": "22100",
      "name": "FBNBANK - UVIRA",
      "shortName": "UVIRA"
    },
    {
      "branchCode": "21400",
      "name": "FBNBANK KIMPESE",
      "shortName": "KIMPESE"
    },
    {
      "branchCode": "25500",
      "name": "FBNBANK KOLWEZI",
      "shortName": "KOLWEZI"
    },
    {
      "branchCode": "26000",
      "name": "FBNBANK MBANDAKA",
      "shortName": "MBANDAKA"
    },
    {
      "branchCode": "21200",
      "name": "FBNBANK MBANZA NGUNGU",
      "shortName": "NGUNGU"
    },
    {
      "branchCode": "21300",
      "name": "FBNBANK MUANDA",
      "shortName": "MUANDA"
    },
    {
      "branchCode": "00421",
      "name": "KINSHASA",
      "shortName": "KINSHASA"
    },
    {
      "branchCode": "00450",
      "name": "KISANGANI",
      "shortName": "KISANGANI"
    },
    {
      "branchCode": "00434",
      "name": "KOLWEZI",
      "shortName": "KOLWEZI"
    },
    {
      "branchCode": "00430",
      "name": "LUBUMBASHI",
      "shortName": "LUBUMBASHI"
    }
  ],
  "00015": [
    {
      "branchCode": "00842",
      "name": "GOMA",
      "shortName": "GOMA"
    },
    {
      "branchCode": "01006",
      "name": "GOMA",
      "shortName": "GOMA"
    },
    {
      "branchCode": "01002",
      "name": "KINSHASA SIEGE",
      "shortName": "KINSHASA S"
    },
    {
      "branchCode": "01003",
      "name": "LUBUMBASHI",
      "shortName": "LUBUMBASH"
    },
    {
      "branchCode": "00843",
      "name": "LUBUMBASHI",
      "shortName": "LUBUMBASHI"
    },
    {
      "branchCode": "08421",
      "name": "MATADI",
      "shortName": "MATADI"
    },
    {
      "branchCode": "00841",
      "name": "RDC",
      "shortName": "RDC"
    },
    {
      "branchCode": "10020",
      "name": "STANDARD BANK KINSHASA",
      "shortName": "KINSHASA"
    }
  ],
  "00017": [
    {
      "branchCode": "21100",
      "name": "AGENCE BOMA",
      "shortName": "AGENCE"
    },
    {
      "branchCode": "00123",
      "name": "AGENCE BOMA",
      "shortName": "KINSHASA"
    },
    {
      "branchCode": "28100",
      "name": "AGENCE DE BENI",
      "shortName": "AGENCE"
    },
    {
      "branchCode": "22000",
      "name": "AGENCE DE BUKAVU",
      "shortName": "BUKAVU"
    },
    {
      "branchCode": "28200",
      "name": "AGENCE DE BUTEMBO",
      "shortName": "BUTEMBO"
    },
    {
      "branchCode": "26300",
      "name": "AGENCE DE GBADOLITE",
      "shortName": "GBADOLITE"
    },
    {
      "branchCode": "26500",
      "name": "AGENCE DE GEMENA",
      "shortName": "GEMENA"
    },
    {
      "branchCode": "23005",
      "name": "AGENCE DE GOMA",
      "shortName": "GOMA"
    },
    {
      "branchCode": "28008",
      "name": "AGENCE DE GOMA",
      "shortName": "GOMA"
    },
    {
      "branchCode": "11003",
      "name": "AGENCE DE GOMA",
      "shortName": "GOMA"
    },
    {
      "branchCode": "25500",
      "name": "AGENCE DE KOLWEZI",
      "shortName": "AGENCE DE"
    },
    {
      "branchCode": "25600",
      "name": "AGENCE DE LIKASI",
      "shortName": "LIKASI"
    },
    {
      "branchCode": "27200",
      "name": "AGENCE DE LODJA",
      "shortName": "LODJA"
    },
    {
      "branchCode": "26000",
      "name": "AGENCE DE MBANDAKA",
      "shortName": "MBANDAKA"
    },
    {
      "branchCode": "28010",
      "name": "AGENCE GDE BARRIERE 2 GOMA",
      "shortName": "GDE BARRIE"
    },
    {
      "branchCode": "25200",
      "name": "AGENCE KASUMBALESA",
      "shortName": "KASUMBALES"
    },
    {
      "branchCode": "20300",
      "name": "AGENCE KENGE",
      "shortName": "AGENCE KEN"
    },
    {
      "branchCode": "21500",
      "name": "AGENCE KITONA",
      "shortName": "KITONA"
    },
    {
      "branchCode": "25002",
      "name": "AGENCE LA PLAGE",
      "shortName": "AGENCE LA"
    },
    {
      "branchCode": "21000",
      "name": "AGENCE MATADI",
      "shortName": "AGENCE MAT"
    },
    {
      "branchCode": "21300",
      "name": "AGENCE MOANDA",
      "shortName": "MOANDA"
    },
    {
      "branchCode": "22006",
      "name": "AGENCE TMB BUKAVU 2",
      "shortName": "BUKAVU 2"
    },
    {
      "branchCode": "22004",
      "name": "AGENCE TMB GOMA",
      "shortName": "TMB GOMA"
    },
    {
      "branchCode": "11001",
      "name": "AGENCE TMB LINGWALA KINSHASA",
      "shortName": "LINGWALA"
    },
    {
      "branchCode": "23200",
      "name": "AGENCE TSHIKAPA",
      "shortName": "AGENCE"
    },
    {
      "branchCode": "20000",
      "name": "BANDUNDU VILLE",
      "shortName": "BANDUNDU"
    },
    {
      "branchCode": "01271",
      "name": "BENI",
      "shortName": "BENI"
    },
    {
      "branchCode": "01270",
      "name": "BUKAVU",
      "shortName": "BUKAVU"
    },
    {
      "branchCode": "22002",
      "name": "BUKAVU PANORAMA",
      "shortName": "PANORAMA"
    },
    {
      "branchCode": "22005",
      "name": "BUKAVU PANORAMA",
      "shortName": "PANORAMA"
    },
    {
      "branchCode": "01252",
      "name": "BUNIA",
      "shortName": "BUNIA"
    },
    {
      "branchCode": "01235",
      "name": "FUNGURUME",
      "shortName": "FUNGURUME"
    },
    {
      "branchCode": "25700",
      "name": "FUNGURUME",
      "shortName": "FUNGURUME"
    },
    {
      "branchCode": "01272",
      "name": "GOMA",
      "shortName": "GOMA"
    },
    {
      "branchCode": "28009",
      "name": "GOMA",
      "shortName": "GOMA"
    },
    {
      "branchCode": "28004",
      "name": "GOMA IHUSI HOTEL",
      "shortName": "IHUSI"
    },
    {
      "branchCode": "28002",
      "name": "GOMA JAMBO SAFARI",
      "shortName": "SAFARI"
    },
    {
      "branchCode": "28005",
      "name": "GOMA TMB PLUS",
      "shortName": "PLUS"
    },
    {
      "branchCode": "24001",
      "name": "GUICHET MONUSCO KISANGANI",
      "shortName": "GUICHET"
    },
    {
      "branchCode": "11019",
      "name": "HOTEL DU FLEUVE",
      "shortName": "HOTEL DU"
    },
    {
      "branchCode": "11020",
      "name": "HOTEL DU GOUVERNEM",
      "shortName": "GOUVERNEM"
    },
    {
      "branchCode": "27100",
      "name": "KABINDA",
      "shortName": "KABINDA"
    },
    {
      "branchCode": "25100",
      "name": "KAMINA",
      "shortName": "KAMIN"
    },
    {
      "branchCode": "25101",
      "name": "KAMINA FARDC",
      "shortName": "KAMINA"
    },
    {
      "branchCode": "01290",
      "name": "KANANGA",
      "shortName": "KANANGA"
    },
    {
      "branchCode": "00012",
      "name": "KINSHASA",
      "shortName": "KINSHASA"
    },
    {
      "branchCode": "20100",
      "name": "KINSHASA   20100",
      "shortName": "KINSHASA20"
    },
    {
      "branchCode": "11022",
      "name": "KINSHASA BANDAL",
      "shortName": "BANDAL"
    },
    {
      "branchCode": "11017",
      "name": "KINSHASA MATETE",
      "shortName": "MATETE"
    },
    {
      "branchCode": "11004",
      "name": "KINSHASA MEMLING",
      "shortName": "MEMLING"
    },
    {
      "branchCode": "11021",
      "name": "KINSHASA MEMLING 2",
      "shortName": "MEMLING 2"
    },
    {
      "branchCode": "11018",
      "name": "KINSHASA NDJILI",
      "shortName": "NDJILI"
    },
    {
      "branchCode": "11014",
      "name": "KINSHASA SHOPRITE",
      "shortName": "SHOPRITE"
    },
    {
      "branchCode": "11016",
      "name": "KINSHASA UPN",
      "shortName": "UPN"
    },
    {
      "branchCode": "50012",
      "name": "KISANGANI 2",
      "shortName": "KISANGANI"
    },
    {
      "branchCode": "01234",
      "name": "KOLWEZI",
      "shortName": "KOLWEZ"
    },
    {
      "branchCode": "21001",
      "name": "LEDYA MATADI",
      "shortName": "LEDYA MATA"
    },
    {
      "branchCode": "01232",
      "name": "LIKASI",
      "shortName": "LIKASI"
    },
    {
      "branchCode": "25008",
      "name": "LSHI ARMEE POLICE",
      "shortName": "LSHI ARME"
    },
    {
      "branchCode": "25009",
      "name": "LSHI CARREFOUR",
      "shortName": "LSHI CAR"
    },
    {
      "branchCode": "25010",
      "name": "LSHI GALERIE AZZAZ",
      "shortName": "LSHI GALER"
    },
    {
      "branchCode": "25006",
      "name": "LSHI RUA",
      "shortName": "LSHI RUA"
    },
    {
      "branchCode": "25003",
      "name": "LSHI STADE MAZEMBE",
      "shortName": "LSHI STADE"
    },
    {
      "branchCode": "01202",
      "name": "LUBUMBASHI",
      "shortName": "LUBUMBASH"
    },
    {
      "branchCode": "01230",
      "name": "LUBUMBASHI",
      "shortName": "LUBUMBAS"
    },
    {
      "branchCode": "25000",
      "name": "LUBUMBASHI LUMUMBA",
      "shortName": "LUMUMBA"
    },
    {
      "branchCode": "28006",
      "name": "MAIRIE  GOMA",
      "shortName": "MAIRIE"
    },
    {
      "branchCode": "01260",
      "name": "MBUJI MAYI",
      "shortName": "MBUJI MAY"
    },
    {
      "branchCode": "01201",
      "name": "MERCHANT BANK",
      "shortName": "MERCHANT"
    },
    {
      "branchCode": "28101",
      "name": "MONUSCO BENI",
      "shortName": "MONUSCO"
    },
    {
      "branchCode": "22001",
      "name": "MONUSCO BUKAVU",
      "shortName": "MONUSCO"
    },
    {
      "branchCode": "24101",
      "name": "MONUSCO BUNIA",
      "shortName": "MONUSCO"
    },
    {
      "branchCode": "28003",
      "name": "MONUSCO GOMA 2",
      "shortName": "GOMA 2"
    },
    {
      "branchCode": "28001",
      "name": "MONUSCO GOMA BRAVO",
      "shortName": "BRAVO"
    },
    {
      "branchCode": "22101",
      "name": "MONUSCO UVIRA",
      "shortName": "UVIRA"
    },
    {
      "branchCode": "27300",
      "name": "MWENE-DITU",
      "shortName": "MWENE"
    },
    {
      "branchCode": "22003",
      "name": "TMB  AGENCE DE BUKAVU",
      "shortName": "BUKAVU"
    },
    {
      "branchCode": "24000",
      "name": "TMB  KISANGANI",
      "shortName": "KISANGAN"
    },
    {
      "branchCode": "24100",
      "name": "TMB - AGENCE DE BUNIA",
      "shortName": "BUNIA"
    },
    {
      "branchCode": "28000",
      "name": "TMB - AGENCE DE GOMA",
      "shortName": "GOMA"
    },
    {
      "branchCode": "25300",
      "name": "TMB - AGENCE DE KALEMIE",
      "shortName": "KALEMIE"
    },
    {
      "branchCode": "25301",
      "name": "TMB - AGENCE DE KALEMIE GUICHE",
      "shortName": "GUICHE"
    },
    {
      "branchCode": "23000",
      "name": "TMB - AGENCE DE KANANGA",
      "shortName": "KANANGA"
    },
    {
      "branchCode": "11002",
      "name": "TMB - AGENCE KINSHASA BOULEVAR",
      "shortName": "BOULEVARD"
    },
    {
      "branchCode": "10000",
      "name": "TMB - AGENCE URGENCE",
      "shortName": "AG URGENCE"
    },
    {
      "branchCode": "22100",
      "name": "TMB - AGENCE UVIRA",
      "shortName": "UVIRA"
    },
    {
      "branchCode": "28007",
      "name": "TMB - GOMA SIEGE",
      "shortName": "GOMA SIEGE"
    },
    {
      "branchCode": "11005",
      "name": "TMB - LIMETE PLACE COMMERCIALE",
      "shortName": "PLACE COMM"
    },
    {
      "branchCode": "88100",
      "name": "TMB AGENCE DE BENI",
      "shortName": "BENI"
    },
    {
      "branchCode": "29009",
      "name": "TMB AGENCE DE GOMA",
      "shortName": "GOMA"
    },
    {
      "branchCode": "25004",
      "name": "TMB AGENCE LSHI MOE",
      "shortName": "LSHI MOE"
    },
    {
      "branchCode": "26100",
      "name": "TMB AGENCE UVIRA",
      "shortName": "UVIRA"
    },
    {
      "branchCode": "25005",
      "name": "TMB KILWA",
      "shortName": "KILWA"
    },
    {
      "branchCode": "29000",
      "name": "TMB KINDU",
      "shortName": "KINDU"
    },
    {
      "branchCode": "11015",
      "name": "TMB KINSHASA  ARMEE POLICE",
      "shortName": "ARMEE"
    },
    {
      "branchCode": "11007",
      "name": "TMB KINSHASA LIMETE PLAZA",
      "shortName": "PLAZA"
    },
    {
      "branchCode": "25001",
      "name": "TMB LUBUMBASHI",
      "shortName": "TMB LUBUMB"
    },
    {
      "branchCode": "27000",
      "name": "TMB MBUJI MAYI",
      "shortName": "MBUJI MAYI"
    },
    {
      "branchCode": "11006",
      "name": "TMB- AGENCE BON MARCHE",
      "shortName": "BON MARCHE"
    },
    {
      "branchCode": "25007",
      "name": "TMB- AGENCE LSHI RUASHI HYPER",
      "shortName": "RUASHI"
    },
    {
      "branchCode": "11000",
      "name": "TMB- PLACE DU MARCHE",
      "shortName": "DU MARCHE"
    },
    {
      "branchCode": "11010",
      "name": "TRUST MERCHANT BANK - GARE CEN",
      "shortName": "GARE CENTR"
    },
    {
      "branchCode": "11013",
      "name": "TRUST MERCHANT BANK - KINSHASA",
      "shortName": "KINSHASA M"
    },
    {
      "branchCode": "11009",
      "name": "TRUST MERCHANT BANK - MACAMPAG",
      "shortName": "MACAMPAG"
    },
    {
      "branchCode": "11012",
      "name": "TRUST MERCHANT BANK - MONUSCO",
      "shortName": "MONUSCO UT"
    },
    {
      "branchCode": "01250",
      "name": "TRUST MERCHANT BANK KISANGANI",
      "shortName": "KISANGANI"
    },
    {
      "branchCode": "11011",
      "name": "TRUST MERCHANT BANK-MONUSCO HQ",
      "shortName": "MONUSCO HQ"
    }
  ],
  "00018": [
    {
      "branchCode": "00300",
      "name": "ACCES BANK KINSHASA- HUILLERIE",
      "shortName": "HUILLERIE"
    },
    {
      "branchCode": "00400",
      "name": "ACCES BANK LUBUMBASHI",
      "shortName": "LUBUMBASHI"
    },
    {
      "branchCode": "00008",
      "name": "BUSINESS",
      "shortName": "BUSINESS"
    },
    {
      "branchCode": "00502",
      "name": "EQUITY  KINSHASA - GOMBE",
      "shortName": "GOMBE"
    },
    {
      "branchCode": "00501",
      "name": "EQUITY BANK",
      "shortName": "EQUITY"
    },
    {
      "branchCode": "00500",
      "name": "EQUITY BANK  GOMBE",
      "shortName": "EQUITY"
    },
    {
      "branchCode": "09530",
      "name": "EQUITY BANK CONGO SA LUBUMBASH",
      "shortName": "LUBUMBASH"
    },
    {
      "branchCode": "09521",
      "name": "EQUITY BANK CONGO SA MATADI",
      "shortName": "SA MATADI"
    },
    {
      "branchCode": "09502",
      "name": "EQUITY BANK CONGO SA MATADI",
      "shortName": "CONGO SA M"
    },
    {
      "branchCode": "00049",
      "name": "EQUITY BANK HOTEL DU FLEUVE",
      "shortName": "DU FLEUVE"
    },
    {
      "branchCode": "00130",
      "name": "EQUITY BANK KINSHASA",
      "shortName": "KINSHASA"
    },
    {
      "branchCode": "00047",
      "name": "EQUITY SIEGE",
      "shortName": "SIEGE"
    },
    {
      "branchCode": "00030",
      "name": "ESPACE HASSON",
      "shortName": "ESPACE HAS"
    },
    {
      "branchCode": "00028",
      "name": "GOMA CENTRE VILLE",
      "shortName": "GOMA CENTR"
    },
    {
      "branchCode": "00021",
      "name": "HUILLERIES",
      "shortName": "HUILLERIES"
    },
    {
      "branchCode": "00023",
      "name": "JUIN HUILLERIES",
      "shortName": "JUIN HUILL"
    },
    {
      "branchCode": "00018",
      "name": "KIN MAZIERE",
      "shortName": "KIN MAZIER"
    },
    {
      "branchCode": "00007",
      "name": "KINTAMBO",
      "shortName": "KINTAMBO"
    },
    {
      "branchCode": "00027",
      "name": "KOLWEZI",
      "shortName": "KOLWEZI"
    },
    {
      "branchCode": "00009",
      "name": "LIMETE",
      "shortName": "LIMETE"
    },
    {
      "branchCode": "00016",
      "name": "LUBUMBASH",
      "shortName": "LUBUMBASH"
    },
    {
      "branchCode": "00022",
      "name": "LUBUMBASHI 2",
      "shortName": "LUBUMBASHI"
    },
    {
      "branchCode": "00010",
      "name": "MANDELA",
      "shortName": "MANDELA"
    },
    {
      "branchCode": "00012",
      "name": "MATADI",
      "shortName": "MATADI"
    },
    {
      "branchCode": "00013",
      "name": "MATADI KIBALA",
      "shortName": "MATADI KIB"
    },
    {
      "branchCode": "00029",
      "name": "MATADI PORT",
      "shortName": "MATADI POR"
    },
    {
      "branchCode": "00015",
      "name": "MATETE",
      "shortName": "MATETE"
    },
    {
      "branchCode": "00017",
      "name": "MBANZA NGUNGU",
      "shortName": "MBANZA NGU"
    },
    {
      "branchCode": "00024",
      "name": "MONDJIBA",
      "shortName": "MONDJIBA"
    },
    {
      "branchCode": "00026",
      "name": "MONISHOP",
      "shortName": "MONISHOP"
    },
    {
      "branchCode": "00011",
      "name": "NGABA",
      "shortName": "NGABA"
    },
    {
      "branchCode": "00006",
      "name": "PAIX",
      "shortName": "PAIX"
    },
    {
      "branchCode": "00001",
      "name": "PROCREDIT BANK  GOMBE SIEGE",
      "shortName": "GOMBE SIEG"
    },
    {
      "branchCode": "00031",
      "name": "PROCREDIT BANK 30 JUIN POSTE",
      "shortName": "JUIN POST"
    },
    {
      "branchCode": "00037",
      "name": "PROCREDIT BANK BRIKIN",
      "shortName": "BANK BRIKI"
    },
    {
      "branchCode": "00040",
      "name": "PROCREDIT BANK BUKAVU",
      "shortName": "BANK BUKAV"
    },
    {
      "branchCode": "00039",
      "name": "PROCREDIT BANK DELVAUX",
      "shortName": "BANK DELVA"
    },
    {
      "branchCode": "00004",
      "name": "PROCREDIT BANK FORMATION",
      "shortName": "FORMATION"
    },
    {
      "branchCode": "00042",
      "name": "PROCREDIT BANK FUNGURUME",
      "shortName": "FUNGURUME"
    },
    {
      "branchCode": "00044",
      "name": "PROCREDIT BANK KASUMBALESA",
      "shortName": "KASUMBALES"
    },
    {
      "branchCode": "00043",
      "name": "PROCREDIT BANK KINKOLE",
      "shortName": "KINKOLE"
    },
    {
      "branchCode": "00045",
      "name": "PROCREDIT BANK LAKENYA",
      "shortName": "LAKENYA"
    },
    {
      "branchCode": "00041",
      "name": "PROCREDIT BANK LIKASI",
      "shortName": "BANK LIKAS"
    },
    {
      "branchCode": "00036",
      "name": "PROCREDIT BANK LUKUSA",
      "shortName": "LUKUSA"
    },
    {
      "branchCode": "00003",
      "name": "PROCREDIT BANK MACAMPAGNE",
      "shortName": "MACAMPAGNE"
    },
    {
      "branchCode": "00033",
      "name": "PROCREDIT BANK MASINA SANS FIL",
      "shortName": "SANS FIL"
    },
    {
      "branchCode": "00032",
      "name": "PROCREDIT BANK MATADI PORT SEC",
      "shortName": "PORT SEC"
    },
    {
      "branchCode": "00002",
      "name": "PROCREDIT BANK NDJILI",
      "shortName": "BANK NDJIL"
    },
    {
      "branchCode": "00034",
      "name": "PROCREDIT BANK PASCAL",
      "shortName": "BANK PASCA"
    },
    {
      "branchCode": "00025",
      "name": "PROCREDIT BANK PLAZA",
      "shortName": "PROCREDIT"
    },
    {
      "branchCode": "86000",
      "name": "PROCREDIT BANK SIEGE 86000",
      "shortName": "SIEGE 8600"
    },
    {
      "branchCode": "00005",
      "name": "PROCREDIT BANK VICTOIRE",
      "shortName": "VICTOIRE"
    },
    {
      "branchCode": "00020",
      "name": "SAIO",
      "shortName": "SAIO"
    },
    {
      "branchCode": "20333",
      "name": "SOFI - BANQUE",
      "shortName": "BANQUE"
    },
    {
      "branchCode": "22133",
      "name": "SOFIBANQUE 22133",
      "shortName": "SOFIBANQUE"
    },
    {
      "branchCode": "20400",
      "name": "SOFIBANQUE KINSHASA SIEGE 2040",
      "shortName": "KINSHASA"
    },
    {
      "branchCode": "20310",
      "name": "SOFIBANQUE- FLAMBEAU",
      "shortName": "FLAMBEAU"
    },
    {
      "branchCode": "20433",
      "name": "SOFIBANQUE- KINSHASA",
      "shortName": "KINSHASA"
    },
    {
      "branchCode": "00014",
      "name": "UPN",
      "shortName": "UPN"
    },
    {
      "branchCode": "00019",
      "name": "VICTOIRE 2",
      "shortName": "VICTOIRE 2"
    }
  ],
  "00019": [
    {
      "branchCode": "00006",
      "name": "AFRILAND BANK GOMA",
      "shortName": "GOMA"
    },
    {
      "branchCode": "00015",
      "name": "AFRILAND FIRST BANK",
      "shortName": "AFRILAND"
    },
    {
      "branchCode": "01330",
      "name": "AFRILAND FIRST BANK  LUBUMBASH",
      "shortName": "AFRILANDL"
    },
    {
      "branchCode": "01320",
      "name": "AFRILAND FIRST BANK BOMA",
      "shortName": "AFRILANDB"
    },
    {
      "branchCode": "00002",
      "name": "AFRILAND FIRST BANK BOMA",
      "shortName": "AFRILANDB"
    },
    {
      "branchCode": "00019",
      "name": "AFRILAND FIRST BANK BUKAVU",
      "shortName": "BUKAVU"
    },
    {
      "branchCode": "01301",
      "name": "AFRILAND FIRST BANK CONGO",
      "shortName": "AFRILAND"
    },
    {
      "branchCode": "01335",
      "name": "AFRILAND FIRST BANK FUNGURUME",
      "shortName": "AFRILANDF"
    },
    {
      "branchCode": "00004",
      "name": "AFRILAND FIRST BANK GEMENA",
      "shortName": "AFRILANDGE"
    },
    {
      "branchCode": "01302",
      "name": "AFRILAND FIRST BANK GOMA",
      "shortName": "AFRILANDG"
    },
    {
      "branchCode": "00010",
      "name": "AFRILAND FIRST BANK HAUT LOMAM",
      "shortName": "AFRILANDL"
    },
    {
      "branchCode": "00008",
      "name": "AFRILAND FIRST BANK KALEMIE",
      "shortName": "AFRILANDKA"
    },
    {
      "branchCode": "01334",
      "name": "AFRILAND FIRST BANK KOLWEZI",
      "shortName": "AFRILAND F"
    },
    {
      "branchCode": "00007",
      "name": "AFRILAND FIRST BANK KOLWEZI",
      "shortName": "AFRILANDKO"
    },
    {
      "branchCode": "00017",
      "name": "AFRILAND FIRST BANK KWANGO",
      "shortName": "KWANGO"
    },
    {
      "branchCode": "00003",
      "name": "AFRILAND FIRST BANK LUBUMBASHI",
      "shortName": "AFRILANDL"
    },
    {
      "branchCode": "00005",
      "name": "AFRILAND FIRST BANK MATADI",
      "shortName": "AFRILANDM"
    },
    {
      "branchCode": "00001",
      "name": "AFRILAND FIRST BANK SIEGE",
      "shortName": "AFRILANDS"
    },
    {
      "branchCode": "01321",
      "name": "AFRILAND FIRST BANK SIEGE X",
      "shortName": "AFRILANDSX"
    },
    {
      "branchCode": "00012",
      "name": "AFRILAND FIRST BANK TSHIKAPA",
      "shortName": "AFRILANDT"
    },
    {
      "branchCode": "00009",
      "name": "AFRILAND FIRST NORD UBANGI",
      "shortName": "AFRILANDU"
    }
  ],
  "00020": [
    {
      "branchCode": "25101",
      "name": "KINSHASA",
      "shortName": "KINSHASA"
    },
    {
      "branchCode": "00001",
      "name": "SOLIDAIRE BANQUE",
      "shortName": "SOLIDAIRE"
    },
    {
      "branchCode": "00010",
      "name": "SOLIDAIRE BANQUE  KINSHASA",
      "shortName": "SOLIDAIRE"
    },
    {
      "branchCode": "01601",
      "name": "SOLIDAIRE BANQUE INTERNATIONAL",
      "shortName": "SOLIDAIRE"
    }
  ],
  "00021": [
    {
      "branchCode": "00500",
      "name": "ACCESS BANK LIMETE",
      "shortName": "LIMETE"
    },
    {
      "branchCode": "00600",
      "name": "ACCESS BANK MATADI",
      "shortName": "MATADI"
    },
    {
      "branchCode": "00200",
      "name": "GOMA",
      "shortName": "GOMA"
    },
    {
      "branchCode": "00300",
      "name": "GOMBE",
      "shortName": "GOMBE"
    },
    {
      "branchCode": "00100",
      "name": "HEAD OFFICE",
      "shortName": "HEAD OFFIC"
    }
  ],
  "00023": [
    {
      "branchCode": "23133",
      "name": "SOFIBANQUE",
      "shortName": "SOFIBANQUE"
    },
    {
      "branchCode": "20433",
      "name": "SOFIBANQUE AGENCE DE NGALIEMA",
      "shortName": "NGALIEMA"
    },
    {
      "branchCode": "20100",
      "name": "SOFIBANQUE AGENCE DU SIEGE",
      "shortName": "DU SIEGE"
    },
    {
      "branchCode": "20190",
      "name": "SOFIBANQUE AGENCE DU SIEGE",
      "shortName": "SOFIBANQUE"
    },
    {
      "branchCode": "20133",
      "name": "SOFIBANQUE KINSHASA SIEGE",
      "shortName": "SOFIBANQUE"
    },
    {
      "branchCode": "22133",
      "name": "SOFIBANQUE MATADI",
      "shortName": "SOFIBANQUE"
    }
  ],
  "00026": [
    {
      "branchCode": "00001",
      "name": "ECOBANK",
      "shortName": "ECOBANK"
    },
    {
      "branchCode": "00010",
      "name": "ECOBANK  MATADI",
      "shortName": "MATADI"
    },
    {
      "branchCode": "00006",
      "name": "ECOBANK - 00006",
      "shortName": "ECOBANK"
    },
    {
      "branchCode": "00007",
      "name": "ECOBANK - 00007",
      "shortName": "ECOBANK"
    },
    {
      "branchCode": "00017",
      "name": "ECOBANK - AGENCE DU SIEGE",
      "shortName": "DU SIEGE"
    },
    {
      "branchCode": "00009",
      "name": "ECOBANK BUNIA VILLE",
      "shortName": "BUNIA VILL"
    },
    {
      "branchCode": "00003",
      "name": "ECOBANK GOMA",
      "shortName": "GOMA"
    },
    {
      "branchCode": "00004",
      "name": "ECOBANK KINSHASA",
      "shortName": "KINSHASA"
    },
    {
      "branchCode": "00014",
      "name": "ECOBANK KINSHASA LIMETE",
      "shortName": "LIMETE"
    },
    {
      "branchCode": "00018",
      "name": "ECOBANK KISANGANI",
      "shortName": "KISANGANI"
    },
    {
      "branchCode": "00005",
      "name": "ECOBANK KOLWEZI",
      "shortName": "KOLWEZI"
    },
    {
      "branchCode": "00002",
      "name": "ECOBANK LUBUMBASHI",
      "shortName": "LUBUMBASHI"
    }
  ],
  "00028": [
    {
      "branchCode": "00201",
      "name": "ADVANS BANK KIKWIT",
      "shortName": "KIKWIT"
    },
    {
      "branchCode": "00560",
      "name": "ADVANS BANK MBUJIMAYI",
      "shortName": "MBUJIMAYI"
    },
    {
      "branchCode": "00106",
      "name": "ADVANS BANK/KINSHASA",
      "shortName": "KINSHASA"
    },
    {
      "branchCode": "00501",
      "name": "ADVANS BANQUE KANANGA",
      "shortName": "KANANGA"
    },
    {
      "branchCode": "00101",
      "name": "ADVANS BANQUE KINSHASA SIEGE",
      "shortName": "SIEGE"
    },
    {
      "branchCode": "00104",
      "name": "ADVANS BANQUE LEMBA",
      "shortName": "LEMBA"
    },
    {
      "branchCode": "00103",
      "name": "ADVANS BANQUE MASINA",
      "shortName": "MASINA"
    },
    {
      "branchCode": "00409",
      "name": "ADVANS BANQUE MBUJI MAYI",
      "shortName": "MBUJI MAY"
    },
    {
      "branchCode": "00100",
      "name": "ADVANS BANQUE SIEGE",
      "shortName": "SIEGE"
    },
    {
      "branchCode": "00301",
      "name": "ADVANS BANQUE TSHIKAPA",
      "shortName": "TSHIKAPA"
    },
    {
      "branchCode": "00030",
      "name": "ADVANS BANQUE TSHIKAPA",
      "shortName": "BANQUE TSH"
    },
    {
      "branchCode": "00401",
      "name": "ADVANS MBUJI - MAYI",
      "shortName": "MAYI"
    }
  ],
  "00029": [
    {
      "branchCode": "25011",
      "name": "BANK OF AFRICA",
      "shortName": "BOA"
    },
    {
      "branchCode": "25030",
      "name": "BANK OF AFRICA  LUBUMBASHI",
      "shortName": "BOA"
    },
    {
      "branchCode": "01000",
      "name": "BANK OF AFRICA 01000",
      "shortName": "BOA"
    },
    {
      "branchCode": "01005",
      "name": "BANK OF AFRICA AGENCE BLVD 30",
      "shortName": "BOA"
    },
    {
      "branchCode": "01006",
      "name": "BANK OF AFRICA AGENCE COMMERCE",
      "shortName": "BOA"
    },
    {
      "branchCode": "01004",
      "name": "BANK OF AFRICA AGENCE DE DELVA",
      "shortName": "BOA"
    },
    {
      "branchCode": "01007",
      "name": "BANK OF AFRICA AGENCE DE GOMA",
      "shortName": "BOA"
    },
    {
      "branchCode": "01016",
      "name": "BANK OF AFRICA AGENCE DE KISAN",
      "shortName": "BOA"
    },
    {
      "branchCode": "01009",
      "name": "BANK OF AFRICA AGENCE DE MONT",
      "shortName": "BOA"
    },
    {
      "branchCode": "01013",
      "name": "BANK OF AFRICA AGENCE DE MSIR",
      "shortName": "BOA"
    },
    {
      "branchCode": "01002",
      "name": "BANK OF AFRICA AGENCE ELITE",
      "shortName": "BOA"
    },
    {
      "branchCode": "01015",
      "name": "BANK OF AFRICA AGENCE PETIT PO",
      "shortName": "BOA"
    },
    {
      "branchCode": "01014",
      "name": "BANK OF AFRICA AGENCE SIGNERS",
      "shortName": "BOA"
    },
    {
      "branchCode": "25070",
      "name": "BANK OF AFRICA BUKAVU",
      "shortName": "BOA"
    },
    {
      "branchCode": "01012",
      "name": "BANK OF AFRICA BUKAVU",
      "shortName": "BOA"
    },
    {
      "branchCode": "01017",
      "name": "BANK OF AFRICA ELITE/CENTRE D'",
      "shortName": "BOA"
    },
    {
      "branchCode": "25072",
      "name": "BANK OF AFRICA GOMA",
      "shortName": "BOA"
    },
    {
      "branchCode": "01008",
      "name": "BANK OF AFRICA KINSHASA",
      "shortName": "BOA"
    },
    {
      "branchCode": "01011",
      "name": "BANK OF AFRICA LUBUMBASHI",
      "shortName": "BOA"
    },
    {
      "branchCode": "01018",
      "name": "BANK OF AFRICA MATADI",
      "shortName": "BOA"
    },
    {
      "branchCode": "01010",
      "name": "BANK OF AFRICA NDJILI",
      "shortName": "BOA"
    },
    {
      "branchCode": "01001",
      "name": "BANK OF AFRICA SIEGE",
      "shortName": "BOA"
    }
  ],
  "00030": [
    {
      "branchCode": "02701",
      "name": "UNITED BANK FOR AFRICA KINSHAS",
      "shortName": "BOA"
    },
    {
      "branchCode": "06899",
      "name": "UNITED BANK FOR AFRICA KINSHAS",
      "shortName": "BOA"
    },
    {
      "branchCode": "02730",
      "name": "UNITED BANK FOR AFRICA LUBUMBA",
      "shortName": "BOA"
    },
    {
      "branchCode": "06801",
      "name": "UNITED BANK FOR AFRICA SIEGE K",
      "shortName": "SIEGE"
    },
    {
      "branchCode": "06806",
      "name": "UNITED BANK OF AFRICA AGENCE D",
      "shortName": "BOA"
    },
    {
      "branchCode": "06804",
      "name": "UNITED BANK OF AFRICA AGENCE K",
      "shortName": "BOA"
    },
    {
      "branchCode": "06805",
      "name": "UNITED BANK OF AFRICA AGENCE L",
      "shortName": "BOA"
    },
    {
      "branchCode": "06803",
      "name": "UNITED BANK OF AFRICA AGENCE T",
      "shortName": "BOA"
    },
    {
      "branchCode": "06802",
      "name": "UNITED BANK OF AFRICA SIEGE KI",
      "shortName": "BOA"
    }
  ],
  "00031": [
    {
      "branchCode": "26021",
      "name": "BGFI BANK - 26021",
      "shortName": "BOA"
    },
    {
      "branchCode": "26720",
      "name": "BGFI BANK - BUNIA 26720",
      "shortName": "BOA"
    },
    {
      "branchCode": "26300",
      "name": "BGFI BANK - LUBUMBASHI",
      "shortName": "BOA"
    },
    {
      "branchCode": "26600",
      "name": "BGFI BANK 26600",
      "shortName": "BOA"
    },
    {
      "branchCode": "26020",
      "name": "BGFI BANK BOMA",
      "shortName": "BOA"
    },
    {
      "branchCode": "26210",
      "name": "BGFI BANK BOMA",
      "shortName": "BOA"
    },
    {
      "branchCode": "26052",
      "name": "BGFI BANK BUNIA",
      "shortName": "BOA"
    },
    {
      "branchCode": "26011",
      "name": "BGFI BANK KINSHASA",
      "shortName": "BOA"
    },
    {
      "branchCode": "26110",
      "name": "BGFI BANK KINSHASA SIEGE",
      "shortName": "BOA"
    },
    {
      "branchCode": "26030",
      "name": "BGFI BANK LUBUMBASHI",
      "shortName": "BOA"
    },
    {
      "branchCode": "26200",
      "name": "BGFI BANK MATADI",
      "shortName": "BOA"
    },
    {
      "branchCode": "26060",
      "name": "BGFI BANK MBUJIMAYI",
      "shortName": "BOA"
    },
    {
      "branchCode": "26900",
      "name": "BGFI BANK SIEGE  KINSHASA",
      "shortName": "BOA"
    },
    {
      "branchCode": "26100",
      "name": "BGFI BANK SIEGE KINSHASA",
      "shortName": "BOA"
    },
    {
      "branchCode": "26111",
      "name": "BGFI BANK SIEGE KINSHASA GOMBE",
      "shortName": "BOA"
    }
  ],
  "00033": [
    {
      "branchCode": "30300",
      "name": "LUBUMBASHI",
      "shortName": "LUBUMBAS"
    }
  ],
  "01": [
    {
      "branchCode": "001",
      "name": "ACCESS BANK CONGO DR",
      "shortName": "BCC"
    }
  ],
  "02": [
    {
      "branchCode": "001",
      "name": "ADVANS BANQUE CONGO",
      "shortName": "BCC"
    }
  ],
  "024": [
    {
      "branchCode": "5023",
      "name": "30JUINHUILERIE BRANCH",
      "shortName": "30JUINHUIL"
    },
    {
      "branchCode": "5031",
      "name": "30JUINPOSTE BRANCH",
      "shortName": "30JUINPOST"
    },
    {
      "branchCode": "15080",
      "name": "ARU BRANCH",
      "shortName": "ARU BRANCH"
    },
    {
      "branchCode": "5048",
      "name": "BANDUNDUVILLE",
      "shortName": "BANDUNDUVI"
    },
    {
      "branchCode": "15066",
      "name": "BENI",
      "shortName": "BENI"
    },
    {
      "branchCode": "15052",
      "name": "BOMA",
      "shortName": "BOMA"
    },
    {
      "branchCode": "5037",
      "name": "BRIKIN BRANCH",
      "shortName": "BRIKIN"
    },
    {
      "branchCode": "15065",
      "name": "BUKAVU",
      "shortName": "BUKAVU"
    },
    {
      "branchCode": "5040",
      "name": "BUKAVU BRANCH",
      "shortName": "BUKAVU"
    },
    {
      "branchCode": "15060",
      "name": "BUNIA",
      "shortName": "BUNIA"
    },
    {
      "branchCode": "5008",
      "name": "BUSINESS BRANCH",
      "shortName": "BUSINESS B"
    },
    {
      "branchCode": "15068",
      "name": "BUTEMBO",
      "shortName": "BUTEMBO"
    },
    {
      "branchCode": "15089",
      "name": "CARREFOUR",
      "shortName": "CARREFOUR"
    },
    {
      "branchCode": "5050",
      "name": "COMMERCE BRANCH",
      "shortName": "COMMERCE"
    },
    {
      "branchCode": "5039",
      "name": "DELVAUX BRANCH",
      "shortName": "DELVAUX"
    },
    {
      "branchCode": "15063",
      "name": "DURBA",
      "shortName": "DURBA"
    },
    {
      "branchCode": "5030",
      "name": "ESPACEHASSON BRANCH",
      "shortName": "ESPACEHASS"
    },
    {
      "branchCode": "5049",
      "name": "FLEUVECONGO BRANCH",
      "shortName": "FLEUVE"
    },
    {
      "branchCode": "5004",
      "name": "FORMATION BRANCH",
      "shortName": "FORMATION"
    },
    {
      "branchCode": "15058",
      "name": "FUNGURUME",
      "shortName": "FUNGURUME"
    },
    {
      "branchCode": "5042",
      "name": "FUNGURUME BRANCH",
      "shortName": "FUNGURUME"
    },
    {
      "branchCode": "5038",
      "name": "GAMBELASPORT BRANCH",
      "shortName": "GAMBELASPO"
    },
    {
      "branchCode": "15091",
      "name": "GOLF BRANCH",
      "shortName": "GOLF BRANC"
    },
    {
      "branchCode": "15067",
      "name": "GOMA",
      "shortName": "GOMA"
    },
    {
      "branchCode": "5028",
      "name": "GOMACENTREVILLE BRANCH",
      "shortName": "GOMACENTRE"
    },
    {
      "branchCode": "5001",
      "name": "GOMBE BRANCH",
      "shortName": "GOMBE"
    },
    {
      "branchCode": "5021",
      "name": "HUILERIE BRANCH",
      "shortName": "HUILERIE"
    },
    {
      "branchCode": "15083",
      "name": "INGA BRANCH",
      "shortName": "INGA BRANC"
    },
    {
      "branchCode": "15061",
      "name": "ISIRO",
      "shortName": "ISIRO"
    },
    {
      "branchCode": "15088",
      "name": "KAMBOVE",
      "shortName": "KAMBOVE"
    },
    {
      "branchCode": "15069",
      "name": "KANANGA",
      "shortName": "KANANGA"
    },
    {
      "branchCode": "5044",
      "name": "KASUMBALESA BRANCH",
      "shortName": "KASUMBALES"
    },
    {
      "branchCode": "15081",
      "name": "KIBALI",
      "shortName": "KIBALI"
    },
    {
      "branchCode": "15054",
      "name": "KIMPESE",
      "shortName": "KIMPESE"
    },
    {
      "branchCode": "15079",
      "name": "KIN UCC MONT NGAFULA",
      "shortName": "KIN UCC"
    },
    {
      "branchCode": "5043",
      "name": "KINKOLE BRANCH",
      "shortName": "KINKOLE"
    },
    {
      "branchCode": "5018",
      "name": "KINMAZIERE BRANCH",
      "shortName": "KINMAZIERE"
    },
    {
      "branchCode": "15075",
      "name": "KINSHASA KITEA",
      "shortName": "KITEA"
    },
    {
      "branchCode": "15078",
      "name": "KINSHASA MARCHE CENTRAL",
      "shortName": "MARCHE"
    },
    {
      "branchCode": "15077",
      "name": "KINSHASA-BRIKIN",
      "shortName": "BRIKIN"
    },
    {
      "branchCode": "15071",
      "name": "KINSHASA-GOMBE",
      "shortName": "GOMBE"
    },
    {
      "branchCode": "15076",
      "name": "KINSHASA-KINTAMBO",
      "shortName": "KINTAMBO"
    },
    {
      "branchCode": "15074",
      "name": "KINSHASA-LHF",
      "shortName": "LHF"
    },
    {
      "branchCode": "15070",
      "name": "KINSHASA-LIMETE",
      "shortName": "LIMETE"
    },
    {
      "branchCode": "15072",
      "name": "KINSHASA-MATONGE",
      "shortName": "MATONGE"
    },
    {
      "branchCode": "15051",
      "name": "KINSHASA-SIEGE",
      "shortName": "KINSHASA-S"
    },
    {
      "branchCode": "15073",
      "name": "KINSHASA-UNIKIN",
      "shortName": "UNIKIN"
    },
    {
      "branchCode": "5007",
      "name": "KINTAMBO BRANCH",
      "shortName": "KINTAMBO"
    },
    {
      "branchCode": "15059",
      "name": "KISANGANI",
      "shortName": "KISANGANI"
    },
    {
      "branchCode": "15057",
      "name": "KOLWEZI",
      "shortName": "KOLWEZI"
    },
    {
      "branchCode": "5027",
      "name": "KOLWEZI BRANCH",
      "shortName": "KOLWEZI"
    },
    {
      "branchCode": "5045",
      "name": "LAKENYA BRANCH",
      "shortName": "LAKENYA"
    },
    {
      "branchCode": "15056",
      "name": "LIKASI",
      "shortName": "LIKASI"
    },
    {
      "branchCode": "5041",
      "name": "LIKASI BRANCH",
      "shortName": "LIKASI"
    },
    {
      "branchCode": "5009",
      "name": "LIMETE BRANCH",
      "shortName": "LIMETE BRA"
    },
    {
      "branchCode": "5035",
      "name": "LIMETE7EME BRANCH",
      "shortName": "LIMETE7EME"
    },
    {
      "branchCode": "15055",
      "name": "LUBUMBASHI",
      "shortName": "LUBUMBASHI"
    },
    {
      "branchCode": "5016",
      "name": "LUBUMBASHI BRANCH",
      "shortName": "LUBUMBASHI"
    },
    {
      "branchCode": "5022",
      "name": "LUBUMBASHI2 BRANCH",
      "shortName": "LUBUMBASHI"
    },
    {
      "branchCode": "15084",
      "name": "LUKALA",
      "shortName": "LUKALA"
    },
    {
      "branchCode": "5036",
      "name": "LUKUSA BRANCH",
      "shortName": "LUKUSA"
    },
    {
      "branchCode": "5003",
      "name": "MACAMPAGNE BRANCH",
      "shortName": "MACAMPAGNE"
    },
    {
      "branchCode": "15082",
      "name": "MAKISO",
      "shortName": "MAKISO"
    },
    {
      "branchCode": "5010",
      "name": "MANDELA BRANCH",
      "shortName": "MANDELA"
    },
    {
      "branchCode": "15087",
      "name": "MANIKA BRANCH",
      "shortName": "MANIKA"
    },
    {
      "branchCode": "5033",
      "name": "MASINASANSFIL BRANCH",
      "shortName": "MASINASANS"
    },
    {
      "branchCode": "15053",
      "name": "MATADI",
      "shortName": "MATADI"
    },
    {
      "branchCode": "5012",
      "name": "MATADI BRANCH",
      "shortName": "MATADI"
    },
    {
      "branchCode": "5013",
      "name": "MATADIKIBALA BRANCH",
      "shortName": "MATADIKIBA"
    },
    {
      "branchCode": "5029",
      "name": "MATADIPORT BRANCH",
      "shortName": "MATADIPORT"
    },
    {
      "branchCode": "5046",
      "name": "MATADIPORT2 BRANCH",
      "shortName": "MATADIPORT"
    },
    {
      "branchCode": "5032",
      "name": "MATADIPORTSEC BRANCH",
      "shortName": "MATADIPORT"
    },
    {
      "branchCode": "5015",
      "name": "MATETE BRANCH",
      "shortName": "MATETE"
    },
    {
      "branchCode": "5017",
      "name": "MBANZANGUNGU BRANCH",
      "shortName": "MBANZANGUN"
    },
    {
      "branchCode": "15064",
      "name": "MBUJIMAYI",
      "shortName": "MBUJIMAYI"
    },
    {
      "branchCode": "5047",
      "name": "MEMLING BRANCH",
      "shortName": "MEMLING"
    },
    {
      "branchCode": "5024",
      "name": "MONDJIBA BRANCH",
      "shortName": "MONDJIBA"
    },
    {
      "branchCode": "15062",
      "name": "MONGBWALU",
      "shortName": "MONGBWALU"
    },
    {
      "branchCode": "5026",
      "name": "MONISHOP BRANCH",
      "shortName": "MONISHOP"
    },
    {
      "branchCode": "5002",
      "name": "NDJILI BRANCH",
      "shortName": "NDJILI"
    },
    {
      "branchCode": "5011",
      "name": "NGABA BRANCH",
      "shortName": "NGABA"
    },
    {
      "branchCode": "15085",
      "name": "OASIS",
      "shortName": "OASIS"
    },
    {
      "branchCode": "5006",
      "name": "PAIX BRANCH",
      "shortName": "PAIX"
    },
    {
      "branchCode": "5034",
      "name": "PASCAL BRANCH",
      "shortName": "PASCAL"
    },
    {
      "branchCode": "15090",
      "name": "PLAGE BRANCH",
      "shortName": "PLAGE BRAN"
    },
    {
      "branchCode": "5025",
      "name": "PLAZA BRANCH",
      "shortName": "PLAZA"
    },
    {
      "branchCode": "15086",
      "name": "ROTANA",
      "shortName": "ROTANA"
    },
    {
      "branchCode": "5020",
      "name": "SAIO BRANCH",
      "shortName": "SAIO"
    },
    {
      "branchCode": "15000",
      "name": "SIEGE",
      "shortName": "SIEGE"
    },
    {
      "branchCode": "5000",
      "name": "SIEGE HEAD OFFICE",
      "shortName": "SIEGE"
    },
    {
      "branchCode": "15092",
      "name": "TSHIKAPA  BRANCH",
      "shortName": "TSHIKAPA"
    },
    {
      "branchCode": "5014",
      "name": "UPN BRANCH",
      "shortName": "UPN"
    },
    {
      "branchCode": "5005",
      "name": "VICTOIRE BRANCH",
      "shortName": "VICTOIRE"
    },
    {
      "branchCode": "5019",
      "name": "VICTOIRE2 BRANCH",
      "shortName": "VICTOIRE2"
    }
  ],
  "03": [
    {
      "branchCode": "001",
      "name": "AFRILAND FIRST BANK CONGO ",
      "shortName": "BCC"
    }
  ],
  "04": [
    {
      "branchCode": "001",
      "name": "BANK OF AFRICA-RDC",
      "shortName": "BCC"
    }
  ],
  "05": [
    {
      "branchCode": "001",
      "name": "BANQUE CENTRALE DU CONGO",
      "shortName": "BCC"
    }
  ],
  "05100": [
    {
      "branchCode": "05190",
      "name": "RAWBANK     KANANGA",
      "shortName": "KANAGA"
    },
    {
      "branchCode": "05175",
      "name": "RAWBANK     KASINDI",
      "shortName": "KASINDI"
    },
    {
      "branchCode": "05173",
      "name": "RAWBANK     KINDU",
      "shortName": "KINDU"
    },
    {
      "branchCode": "15152",
      "name": "RAWBANK    15152",
      "shortName": "15152"
    },
    {
      "branchCode": "05121",
      "name": "RAWBANK    MATADI",
      "shortName": "MATADI"
    },
    {
      "branchCode": "05101",
      "name": "RAWBANK   KINSHASA",
      "shortName": "KINSHASA"
    },
    {
      "branchCode": "01075",
      "name": "RAWBANK   KINSHASA UNIKIN",
      "shortName": "UNIKIN"
    },
    {
      "branchCode": "05132",
      "name": "RAWBANK   LIKASI",
      "shortName": "LIKASI"
    },
    {
      "branchCode": "05120",
      "name": "RAWBANK  BOMA",
      "shortName": "BOMA"
    },
    {
      "branchCode": "05137",
      "name": "RAWBANK  FUNGURUME",
      "shortName": "FUNGURUME"
    },
    {
      "branchCode": "00008",
      "name": "RAWBANK  KINSHASA BANDAL",
      "shortName": "BANDAL"
    },
    {
      "branchCode": "00006",
      "name": "RAWBANK  KINSHASA BARUMBU",
      "shortName": "BARUMBU"
    },
    {
      "branchCode": "00007",
      "name": "RAWBANK  KINSHASA BAYAKA",
      "shortName": "BAYAKA"
    },
    {
      "branchCode": "15101",
      "name": "RAWBANK  KINSHASA LIMETE",
      "shortName": "LIMETE"
    },
    {
      "branchCode": "05134",
      "name": "RAWBANK  KOLWEZI",
      "shortName": "KOLWEZI"
    },
    {
      "branchCode": "00034",
      "name": "RAWBANK  KOLWEZI",
      "shortName": "KOLWEZI"
    },
    {
      "branchCode": "05130",
      "name": "RAWBANK  LUBUMBASHI",
      "shortName": "LUBUMBASHI"
    },
    {
      "branchCode": "15136",
      "name": "RAWBANK  SAKANIA",
      "shortName": "SAKANIA"
    },
    {
      "branchCode": "05171",
      "name": "RAWBANK - BENI",
      "shortName": "BENI"
    },
    {
      "branchCode": "05170",
      "name": "RAWBANK - BUKAVU",
      "shortName": "BUKAVU"
    },
    {
      "branchCode": "05152",
      "name": "RAWBANK - BUNA 05152",
      "shortName": "BUNA 05152"
    },
    {
      "branchCode": "05153",
      "name": "RAWBANK - BUTA",
      "shortName": "BUTA"
    },
    {
      "branchCode": "05174",
      "name": "RAWBANK - BUTEMBO",
      "shortName": "BUTEMBO"
    },
    {
      "branchCode": "10052",
      "name": "RAWBANK - DOKO",
      "shortName": "DOKO"
    },
    {
      "branchCode": "05172",
      "name": "RAWBANK - GOMA",
      "shortName": "GOMA"
    },
    {
      "branchCode": "45121",
      "name": "RAWBANK - INGA",
      "shortName": "RAWBANKING"
    },
    {
      "branchCode": "05151",
      "name": "RAWBANK - ISIRO",
      "shortName": "ISIRO"
    },
    {
      "branchCode": "15170",
      "name": "RAWBANK - KADUTU",
      "shortName": "KADUTU"
    },
    {
      "branchCode": "05141",
      "name": "RAWBANK - KIKWIT",
      "shortName": "KIKWIT"
    },
    {
      "branchCode": "00001",
      "name": "RAWBANK - KINSHASA 00001",
      "shortName": "RAWBANK001"
    },
    {
      "branchCode": "00002",
      "name": "RAWBANK - KINSHASA 00002",
      "shortName": "RAWBANK002"
    },
    {
      "branchCode": "00003",
      "name": "RAWBANK - KINSHASA 00003",
      "shortName": "RAWBANK003"
    },
    {
      "branchCode": "00004",
      "name": "RAWBANK - KINSHASA 00004",
      "shortName": "RAWBANK004"
    },
    {
      "branchCode": "00005",
      "name": "RAWBANK - KINSHASA 00005",
      "shortName": "RAWBANK005"
    },
    {
      "branchCode": "25130",
      "name": "RAWBANK - KINSHASA 25130",
      "shortName": "RAWBANK251"
    },
    {
      "branchCode": "25201",
      "name": "RAWBANK - KINSHASA 25201",
      "shortName": "RAWBANK250"
    },
    {
      "branchCode": "35101",
      "name": "RAWBANK - KINSHASA 35101",
      "shortName": "RAWBANK101"
    },
    {
      "branchCode": "35130",
      "name": "RAWBANK - KINSHASA 35130",
      "shortName": "RAWBANK351"
    },
    {
      "branchCode": "45101",
      "name": "RAWBANK - KINSHASA 45101",
      "shortName": "RAWBANK451"
    },
    {
      "branchCode": "55101",
      "name": "RAWBANK - KINSHASA 55101",
      "shortName": "RAWBANK551"
    },
    {
      "branchCode": "55130",
      "name": "RAWBANK - KINSHASA 55130",
      "shortName": "RAWBANK551"
    },
    {
      "branchCode": "65101",
      "name": "RAWBANK - KINSHASA 65101",
      "shortName": "RAWBANK651"
    },
    {
      "branchCode": "75101",
      "name": "RAWBANK - KINSHASA 75101",
      "shortName": "RAWBANK751"
    },
    {
      "branchCode": "95101",
      "name": "RAWBANK - KINSHASA 95101",
      "shortName": "RAWBANK951"
    },
    {
      "branchCode": "25101",
      "name": "RAWBANK - KINSHASA AGENCE URBA",
      "shortName": "AGENCE URB"
    },
    {
      "branchCode": "05150",
      "name": "RAWBANK - KISANGANI 05150",
      "shortName": "KISANGANI"
    },
    {
      "branchCode": "05162",
      "name": "RAWBANK - LODJA",
      "shortName": "LODJA"
    },
    {
      "branchCode": "75130",
      "name": "RAWBANK - LUBUMBASHI  M'SIRI",
      "shortName": "RAWBANKMIS"
    },
    {
      "branchCode": "45130",
      "name": "RAWBANK - LUBUMBASHI BEL-AIR",
      "shortName": "RAWBANKBEL"
    },
    {
      "branchCode": "26001",
      "name": "RAWBANK - LUFU",
      "shortName": "LUFU"
    },
    {
      "branchCode": "05163",
      "name": "RAWBANK - LUSAMBO",
      "shortName": "LUSAMBO"
    },
    {
      "branchCode": "05154",
      "name": "RAWBANK - MAHAGI",
      "shortName": "MAHAGI"
    },
    {
      "branchCode": "25121",
      "name": "RAWBANK - MATADI KINKANDA",
      "shortName": "RAWBANKMA"
    },
    {
      "branchCode": "26003",
      "name": "RAWBANK - MBANZA NGUNGU",
      "shortName": "RAWBANKNGU"
    },
    {
      "branchCode": "05160",
      "name": "RAWBANK - MBUJI MAYI",
      "shortName": "MBUJI MAYI"
    },
    {
      "branchCode": "05124",
      "name": "RAWBANK - MUANDA",
      "shortName": "MUANDA"
    },
    {
      "branchCode": "11013",
      "name": "RAWBANK 11013",
      "shortName": "11013"
    },
    {
      "branchCode": "01001",
      "name": "RAWBANK ISC KINSHASA",
      "shortName": "ISC KIN"
    },
    {
      "branchCode": "05126",
      "name": "RAWBANK KIMPESE",
      "shortName": "KIMPESE"
    },
    {
      "branchCode": "00009",
      "name": "RAWBANK KINSHASA 00009",
      "shortName": "00009"
    },
    {
      "branchCode": "26002",
      "name": "RAWBANK KWILUNGONGO",
      "shortName": "KWILUNGONG"
    },
    {
      "branchCode": "05180",
      "name": "RAWBANK MBANDAKA",
      "shortName": "RAWBANK"
    }
  ],
  "06": [
    {
      "branchCode": "001",
      "name": "BANQUE CONGOLAISE",
      "shortName": "BCC"
    }
  ],
  "07": [
    {
      "branchCode": "001",
      "name": "BANQUE COMMERCIALE DU CONGO",
      "shortName": "BCC"
    }
  ],
  "08": [
    {
      "branchCode": "001",
      "name": "SOLIDAIRE BANQUE ",
      "shortName": "SBI"
    }
  ],
  "09": [
    {
      "branchCode": "001",
      "name": "BANQUE INTERNATIONALE POUR ",
      "shortName": "BCC"
    }
  ],
  "10": [
    {
      "branchCode": "001",
      "name": "BGFIBANK RDC",
      "shortName": "BCC"
    }
  ],
  "11": [
    {
      "branchCode": "001",
      "name": "BANQUE DU CREDIT AGRICOLE BCA",
      "shortName": "BCC"
    }
  ],
  "12": [
    {
      "branchCode": "001",
      "name": "CITIBANK CONGO",
      "shortName": "CITI"
    }
  ],
  "13": [
    {
      "branchCode": "001",
      "name": "ECOBANK REPUBLIQUE DEMOCRAT",
      "shortName": "ECO"
    }
  ],
  "14": [
    {
      "branchCode": "001",
      "name": "BANQUE INTERNATIONALE DU",
      "shortName": "ECO"
    }
  ],
  "15": [
    {
      "branchCode": "001",
      "name": "UNION DES BANQUES CONGOLAISES",
      "shortName": "UDC"
    }
  ],
  "16": [
    {
      "branchCode": "001",
      "name": "RAWBANK SA",
      "shortName": "RAW"
    }
  ],
  "17": [
    {
      "branchCode": "001",
      "name": "FIRST INTERNATIONAL BANK",
      "shortName": "SOFI"
    }
  ],
  "18": [
    {
      "branchCode": "001",
      "name": "STANBIC RDC",
      "shortName": "STB"
    }
  ],
  "19": [
    {
      "branchCode": "001",
      "name": "TRUST MERCHANT BANK SA",
      "shortName": "TMB"
    }
  ],
  "20": [
    {
      "branchCode": "001",
      "name": "SOFI BANQUE RDC",
      "shortName": "TMBS"
    }
  ],
  "21": [
    {
      "branchCode": "001",
      "name": "UNITED BANK FOR AFRICA RDC",
      "shortName": "UBA"
    }
  ],
  "68": [
    {
      "branchCode": "15000",
      "name": "BCDC HEAD OFFICE",
      "shortName": "BCDC"
    },
    {
      "branchCode": "000",
      "name": "EQUITY BANK LIMITED",
      "shortName": "EQC"
    }
  ]
}
